<template>
  <v-card height='100%'>
    <v-card-subtitle :class="{'ml-4': this.multiplyChoice}">
      {{ $vuetify.lang.t('$vuetify.charts.driverSpecific') }}
    </v-card-subtitle>
    <v-card-text>
      <v-autocomplete v-model="users" :search-input.sync="search" :items="items"
                      chips
                      deletable-chips
                      cache-items
                      hide-details
                      hide-selected
                      :multiple="multiplyChoice"
                      :loading="items.length === 0"
                      item-text="username" item-value="email"
                      :placeholder="$vuetify.lang.t(this.multiplyChoice ? '$vuetify.reports.emptySearchLabel' : '$vuetify.map.managerMap.defaultSettingsUsers')">

        <template v-slot:item="data">
          <v-list-item-avatar v-if="data.item.isProfilePicture()" size="32">
            <v-img :src="data.item.profilePicture"></v-img>
          </v-list-item-avatar>
          <template v-if="data.item.username !== data.item.email">
            <v-list-item-content>
              <v-list-item-title>{{ data.item.username }}</v-list-item-title>
              <v-list-item-subtitle>{{ data.item.email }}</v-list-item-subtitle>
            </v-list-item-content>
          </template>
          <template v-else>
            <v-list-item-content>{{ data.item.email }}</v-list-item-content>
          </template>
        </template>

      </v-autocomplete>
    </v-card-text>
  </v-card>

</template>

<script>
import backend from '../../backend'
import { User } from '../../models/user/User'
import snackbarMixin from '../../mixins/snackbarMixin'
import { mdiCollapseAll, mdiExpandAll } from '@mdi/js'

export default {
  name: 'DriversSearchAutocomplete',
  mixins: [snackbarMixin],
  props: {
    nanoUsers: {
      type: Boolean,
      default: false
    },
    multiplyChoice: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    users: [],
    items: [],
    search: null,
    addAllToggle: true,

    addAllIcon: mdiExpandAll,
    removeAllIcon: mdiCollapseAll,
  }),
  async created () {
    try {
      const response = await backend.fetchChartDriverList({ nano_users: this.nanoUsers })
      this.items = response.data.data.map(item => new User(item))
    } catch (e) {
      this.processFailedRequest(e)
    }
  },
  watch: {
    users (value) {
      this.$emit('driver-choice', value)
    }
  }
}
</script>

<style scoped>

</style>
